"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseAccountItemBillingDocument = exports.nextItemBillingAnniversary = exports.monthlyItemCredits = exports.CREDIT_PACKS = exports.ITEM_BILLING_PRICING_VERSION = exports.OPERATIONAL_ITEM_LIMIT = exports.ITEMS_PER_CREDIT = exports.FREE_ITEM_ALLOWANCE = void 0;
const paths_1 = require("./paths");
exports.FREE_ITEM_ALLOWANCE = 500;
exports.ITEMS_PER_CREDIT = 20;
exports.OPERATIONAL_ITEM_LIMIT = 100000;
exports.ITEM_BILLING_PRICING_VERSION = 'pricing-2026-10-14-v1';
exports.CREDIT_PACKS = {
    'starter-1000-v1': { credits: 1000, amountMinor: 1000, currency: 'NZD' },
    'regular-3000-v1': { credits: 3000, amountMinor: 2700, currency: 'NZD' },
    'bulk-10000-v1': { credits: 10000, amountMinor: 8000, currency: 'NZD' },
};
const integer = (value, minimum = 0, maximum = Number.MAX_SAFE_INTEGER) => {
    if (!Number.isSafeInteger(value) ||
        Number(value) < minimum ||
        Number(value) > maximum)
        throw new Error('Invalid item billing integer.');
    return Number(value);
};
const timestamp = (value) => {
    if (!value || typeof value !== 'object' || Array.isArray(value))
        throw new Error('Invalid item billing timestamp.');
    const input = value;
    if (input.nanoseconds !== 0)
        throw new Error('Whole-second timestamp required.');
    return { seconds: integer(input.seconds, 0, 253402300799), nanoseconds: 0 };
};
const monthlyItemCredits = (peakItems) => Math.ceil(Math.max(0, integer(peakItems) - exports.FREE_ITEM_ALLOWANCE) / exports.ITEMS_PER_CREDIT);
exports.monthlyItemCredits = monthlyItemCredits;
/** Advance by one UTC calendar month while retaining the original anniversary. */
const nextItemBillingAnniversary = (start, anchorDay, anchorSecondsOfDay) => {
    const validatedStart = timestamp(start);
    integer(anchorDay, 1, 31);
    integer(anchorSecondsOfDay, 0, 86399);
    const date = new Date(validatedStart.seconds * 1000);
    const year = date.getUTCFullYear();
    const month = date.getUTCMonth() + 1;
    const lastDay = new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
    const seconds = Date.UTC(year, month, Math.min(anchorDay, lastDay)) / 1000 +
        anchorSecondsOfDay;
    integer(seconds, validatedStart.seconds + 1, 253402300799);
    return { seconds, nanoseconds: 0 };
};
exports.nextItemBillingAnniversary = nextItemBillingAnniversary;
const parseAccountItemBillingDocument = (value) => {
    if (!value || typeof value !== 'object' || Array.isArray(value))
        throw new Error('Invalid item billing document.');
    const input = value;
    const allowed = [
        'schemaVersion',
        'revision',
        'billingAccountId',
        'anchorDay',
        'anchorSecondsOfDay',
        'periodStart',
        'periodEnd',
        'currentItems',
        'peakItems',
        'pricingVersion',
    ];
    if (Object.keys(input).some((key) => !allowed.includes(key)) ||
        input.schemaVersion !== 1 ||
        input.pricingVersion !== exports.ITEM_BILLING_PRICING_VERSION ||
        typeof input.billingAccountId !== 'string')
        throw new Error('Unsupported item billing document.');
    paths_1.firestorePaths.billingAccount(input.billingAccountId);
    const anchorDay = integer(input.anchorDay, 1, 31);
    const anchorSecondsOfDay = integer(input.anchorSecondsOfDay, 0, 86399);
    const periodStart = timestamp(input.periodStart);
    const periodEnd = timestamp(input.periodEnd);
    const date = new Date(periodStart.seconds * 1000);
    const lastDay = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + 1, 0)).getUTCDate();
    const secondsOfDay = date.getUTCHours() * 3600 +
        date.getUTCMinutes() * 60 +
        date.getUTCSeconds();
    if (date.getUTCDate() !== Math.min(anchorDay, lastDay) ||
        secondsOfDay !== anchorSecondsOfDay ||
        periodEnd.seconds !==
            (0, exports.nextItemBillingAnniversary)(periodStart, anchorDay, anchorSecondsOfDay)
                .seconds)
        throw new Error('Inconsistent anniversary period.');
    const currentItems = integer(input.currentItems);
    const peakItems = integer(input.peakItems, currentItems);
    return {
        schemaVersion: 1,
        revision: integer(input.revision),
        billingAccountId: input.billingAccountId,
        anchorDay,
        anchorSecondsOfDay,
        periodStart,
        periodEnd,
        currentItems,
        peakItems,
        pricingVersion: exports.ITEM_BILLING_PRICING_VERSION,
    };
};
exports.parseAccountItemBillingDocument = parseAccountItemBillingDocument;
